import React, { useEffect, useState } from "react";
import "../Pages.css";
import "react-toastify/dist/ReactToastify.css";
import { Table, Spin } from "antd";
import { EditTwoTone, DeleteTwoTone } from "@ant-design/icons";
import UpdateProjectEffort from "./UpdateProjectEffort";
import DeleteCmfModal from "../../Components/DeleteCmfModal/DeleteCmfModal";

const TableProjectEffort = (props, { searchParams }) => {
	const [editingRecord, setEditingRecord] = useState(null);
	const [pagination, setPagination] = useState({
		current: 1,
		pageSize: 10,
	});
	const [deleteModalData, setDeleteModalData] = useState({
		show: false,
		id: "",
	});

	const [isModalVisible, setIsModalVisible] = useState(false);
	const [loading, setLoading] = useState(true);

	const handleEdit = (record) => {
		setEditingRecord(record);
		setIsModalVisible(true);
	};

	useEffect(() => {
		setLoading(true);
		props.fetchProjectEffort(pagination.current, pagination.pageSize);
		setLoading(false);
	}, [props.searchParams]);

	const handleTableChange = (pagination) => {
		setPagination(pagination);
	};

	const onEdit = (record) => {
		setEditingRecord(record);
	};

	const onDelete = async (id) => {
		props.onDeleteFunction(id);
	};

	const columns = [
		{
			className: "table_heading",
			title: "Department",
			dataIndex: "departmentName",
			width: 120,
		},
		{
			title: "Project Name",
			dataIndex: "azureProjectName",
			width: 130,
		},
		{
			title: "Year",
			dataIndex: "year",
			width: 70,
		},
		{
			title: "Quarter",
			dataIndex: "monthCycle",
			width: 90,
		},
		{
			title: "Effort Variance Compliance",
			dataIndex: "effortVarianceCompliance",
			width: 90,
		},
		{
			title: "Status",
			dataIndex: "status",
			width: 100,
		},
		{
			title: "Comment",
			dataIndex: "comments",
			width: 150,
			render: (text, record) => (
				<div
					style={{
						maxHeight: "80px",
						overflowY: "auto",
						wordWrap: "break-word",
					}}>
					{text}
				</div>
			),
		},
		{
			title: "Submitted By",
			dataIndex: "username",
			width: 90,
		},
		{
			title: "Action",
			width: 80,
			render: (data, record) => (
				<span className="Action-button">
					<EditTwoTone twoToneColor="#00ff00" onClick={() => onEdit(record)} />
					&nbsp;&nbsp;
					<DeleteTwoTone
						twoToneColor="#ff0000"
						onClick={() => setDeleteModalData({ show: true, id: data.id })}
					/>
				</span>
			),
		},
	];

	return (
		<div className="table_main">
			<div className="table_container">
				<Spin spinning={loading}>
					<DeleteCmfModal
						onClick={() => onDelete(deleteModalData?.id)}
						visible={deleteModalData?.show}
						onCancel={() => setDeleteModalData({ show: false, id: "" })}
					/>
					<Table
						className="table_main"
						columns={columns.map((column) => ({ ...column, className: "" }))}
						dataSource={props.projectEffort}
						pagination={pagination}
						onChange={handleTableChange}
						scroll={{
							// y: 500,
							x: 1000,
						}}
					/>
				</Spin>
				<div
					className={`modal fade bd-example-modal-lg ${
						isModalVisible ? "show" : ""
					}`}
					tabIndex="-1"
					role="dialog"
					style={{ display: isModalVisible ? "block" : "none" }}>
					<div className="modal-dialog modal-lg">
						<div className="modal-content">
							<div className="modal-header">
								<h5 className="modal-title">Update Project Effort Variance</h5>
								<button
									type="button"
									className="close"
									data-dismiss="modal"
									aria-label="Close"
									onClick={() => {
										setIsModalVisible(false);
										setEditingRecord(null);
									}}>
									<span aria-hidden="true">&times;</span>
								</button>
							</div>
							<div className="modal-body">
								{editingRecord && (
									<UpdateProjectEffort
										record={editingRecord}
										onUpdate={() => {
											setEditingRecord(false);
										}}
										onUpdateFunction={props.onUpdateFunction}
									/>
								)}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default TableProjectEffort;
